<ng-container *ngIf="!showNotAvailablePage; else notAvailablePage">
  <ng-container *ngIf="cmsPage$ | async as cmsPage">
    <ng-container *ngIf="slots$ | async as slots">
      <div #topSlot kionCmsSlot [component]="getSlot$('topSlot') | async">
        <ng-container *ngIf="slots.includes('topSlot')" >
          <ng-container *ngIf="getComponentsBySlot$('topSlot') | async as components" >
            <kion-platform-header *ngIf="components.length > 0">
              <div title kionCmsComponent [component]="components[0]">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[components[0].typeCode]"
                  [ndcDynamicInputs]="{component: components[0]}"
                ></ndc-dynamic>
              </div>
              <div links *ngFor="let component of components.slice(1, components.length)" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component.typeCode]"
                  [ndcDynamicInputs]="{component: component, class: 'top'}"
                ></ndc-dynamic>
              </div>
            </kion-platform-header>
          </ng-container>
        </ng-container>
      </div>
      <div #headerSlot kionCmsSlot [component]="getSlot$('headerSlot') | async">
        <ng-container *ngIf="slots.includes('headerSlot')">
          <ng-container *ngIf="getComponentsBySlot$('headerSlot') | async as components">
            <kion-platform-menu *ngIf="components.length > 0" [project]="project">
              <div logo  kionCmsComponent [component]="components[0]">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[components[0]?.typeCode]"
                ></ndc-dynamic>
              </div>
              <div navigation kionCmsComponent [component]="components[1]">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[components[1]?.typeCode]"
                ></ndc-dynamic>
              </div>
              <div icons>
                <kion-header-buttons (searchClicked)="searchClicked()"></kion-header-buttons>
              </div>
              <div searchBox *ngIf="searchToggled" class="search-box {{ searchToggled ? 'open' : '' }}">
                <kion-lr-search-box></kion-lr-search-box>
                <div class="search-box-hint"></div>
              </div>
            </kion-platform-menu>
          </ng-container>
        </ng-container>
      </div>
      <div #bannerSlot kionCmsSlot [component]="getSlot$('bannerSlot') | async">
        <ng-container *ngIf="slots.includes('bannerSlot')" >
          <ng-container *ngIf="getComponentsBySlot$('bannerSlot') | async as components">
            <kion-platform-main-content *ngIf="components.length > 0">
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component.typeCode]"
                  [ndcDynamicInputs]="{component: component, page: cmsPage}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div #subHeaderSlot kionCmsSlot [component]="getSlot$('subHeaderSlot') | async">
        <ng-container *ngIf="slots.includes('subHeaderSlot')" >
          <ng-container *ngIf="getComponentsBySlot$('subHeaderSlot') | async as components">
            <kion-platform-sub-header *ngIf="components.length > 0">
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component.typeCode]"
                  [ndcDynamicInputs]="{component: component, page: cmsPage}"
                ></ndc-dynamic>
              </div>
            </kion-platform-sub-header>
          </ng-container>
        </ng-container>
      </div>
      <div #stepAddressSlot kionCmsSlot [component]="getSlot$('stepAddressSlot') | async">
        <ng-container *ngIf="slots.includes('stepAddressSlot') && (step$ | async) === 1" >
          <ng-container *ngIf="getComponentsBySlot$('stepAddressSlot') | async as components">
            <kion-platform-main-content>
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component?.typeCode]"
                  [ndcDynamicInputs]="{component: component}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div #stepDeliverySlot kionCmsSlot [component]="getSlot$('stepDeliverySlot') | async">
        <ng-container *ngIf="slots.includes('stepDeliverySlot') && (step$ | async) === 2" >
          <ng-container *ngIf="getComponentsBySlot$('stepDeliverySlot') | async as components">
            <kion-platform-main-content>
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component?.typeCode]"
                  [ndcDynamicInputs]="{component: component}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div #stepPaymentSlot kionCmsSlot [component]="getSlot$('stepPaymentSlot') | async">
        <ng-container *ngIf="slots.includes('stepPaymentSlot') && (step$ | async) === 3" >
          <ng-container *ngIf="getComponentsBySlot$('stepPaymentSlot') | async as components">
            <kion-platform-main-content>
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component?.typeCode]"
                  [ndcDynamicInputs]="{component: component}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div #stepSummarySlot kionCmsSlot [component]="getSlot$('stepSummarySlot') | async">
        <ng-container *ngIf="slots.includes('stepSummarySlot') && (step$ | async) === 4" >
          <ng-container *ngIf="getComponentsBySlot$('stepSummarySlot') | async as components">
            <kion-platform-main-content>
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component?.typeCode]"
                  [ndcDynamicInputs]="{component: component}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div style="height: 100%" #mainSlot kionCmsSlot [component]="getSlot$('mainSlot') | async">
        <ng-container *ngIf="slots.includes('mainSlot')" >
          <ng-container *ngIf="getComponentsBySlot$('mainSlot') | async as components">
            <kion-platform-main-content style="height: 100%" [fullHeight]="isFullHeight">
              <div style="height: 100%" *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component?.typeCode]"
                  [ndcDynamicInputs]="{component: component, page: cmsPage}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div #mainSlotLeft kionCmsSlot [component]="getSlot$('mainSlotLeft') | async">
        <ng-container *ngIf="slots.includes('mainSlotLeft')" >
          <ng-container *ngIf="getComponentsBySlot$('mainSlotLeft') | async as components">
            <kion-platform-main-content>
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component?.typeCode]"
                  [ndcDynamicInputs]="{component: component}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div #mainSlotRight kionCmsSlot [component]="getSlot$('mainSlotRight') | async">
        <ng-container *ngIf="slots.includes('mainSlotRight')" >
          <ng-container *ngIf="getComponentsBySlot$('mainSlotRight') | async as components">
            <kion-platform-main-content>
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component?.typeCode]"
                  [ndcDynamicInputs]="{component: component}"
                ></ndc-dynamic>
              </div>
            </kion-platform-main-content>
          </ng-container>
        </ng-container>
      </div>
      <div #subFooterSlot  kionCmsSlot [component]="getSlot$('subFooterSlot') | async">
        <ng-container *ngIf="slots.includes('subFooterSlot')">
          <ng-container *ngIf="getComponentsBySlot$('subFooterSlot') | async as components">
            <kion-platform-sub-footer *ngIf="components.length > 0">
              <div *ngFor="let component of components" kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component.typeCode]"
                  [ndcDynamicInputs]="{component: component, page: cmsPage}"
                ></ndc-dynamic>
              </div>
            </kion-platform-sub-footer>
          </ng-container>
        </ng-container>
      </div>
      <div #footerSlot kionCmsSlot [component]="getSlot$('footerSlot') | async">
        <ng-container *ngIf="slots.includes('footerSlot')" >
          <ng-container *ngIf="getComponentsBySlot$('footerSlot') | async as components">
            <kion-platform-footer *ngIf="components.length > 0">
              <ng-container links>
                <div *ngFor="let component of components.slice(0, 2)" kionCmsComponent [component]="component">
                  <ndc-dynamic
                    [ndcDynamicComponent]="componentMapping[component.typeCode]"
                    [ndcDynamicInputs]="{component: component, class: 'footer'}"
                  ></ndc-dynamic>
                </div>
              </ng-container>
              <ng-container mission>
                <div  *ngIf="components[components.length - 1] as component" kionCmsComponent [component]="component">
                  <ndc-dynamic
                    [ndcDynamicComponent]="componentMapping[component.typeCode]"
                    [ndcDynamicInputs]="{component: component, class: 'footer'}"
                  ></ndc-dynamic>
                </div>
              </ng-container>
              <ng-container payment>
                <div *ngIf="components[components.length - 2] as component" kionCmsComponent [component]="component">
                  <ndc-dynamic
                    [ndcDynamicComponent]="componentMapping[component.typeCode]"
                    [ndcDynamicInputs]="{component: component, class: 'footer'}"
                  ></ndc-dynamic>
                </div>
              </ng-container>
            </kion-platform-footer>
          </ng-container>
        </ng-container>
      </div>
      <div #bottomSlot kionCmsSlot [component]="getSlot$('bottomSlot') | async">
        <ng-container *ngIf="slots.includes('bottomSlot')" >
          <ng-container *ngIf="getComponentsBySlot$('bottomSlot') | async as components">
            <kion-platform-bottom *ngIf="components.length > 0">
              <ng-container links>
                <div *ngFor="let component of components.slice(0, components.length - 1)" kionCmsComponent [component]="component">
                  <ndc-dynamic
                    [ndcDynamicComponent]="componentMapping[component.typeCode]"
                    [ndcDynamicInputs]="{component: component, class: 'bottom'}"
                  ></ndc-dynamic>
                </div>
              </ng-container>
              <div copyright  *ngIf="components[components.length - 1] as component"  kionCmsComponent [component]="component">
                <ndc-dynamic
                  [ndcDynamicComponent]="componentMapping[component.typeCode]"
                  [ndcDynamicInputs]="{component: component}"
                ></ndc-dynamic>
              </div>
            </kion-platform-bottom>
          </ng-container>
        </ng-container>
      </div>
      <ndc-dynamic
        [ndcDynamicComponent]="templateMapping[cmsPage.template]"
        [ndcDynamicContent]="[
        [topSlot],
        [headerSlot],
        [bannerSlot],
        [subHeaderSlot],
        [stepAddressSlot],
        [stepDeliverySlot],
        [stepPaymentSlot],
        [stepSummarySlot],
        [mainSlot],
        [mainSlotLeft],
        [mainSlotRight],
        [subFooterSlot],
        [footerSlot],
        [bottomSlot]
    ]"
      ></ndc-dynamic>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #notAvailablePage>
  <kion-cms-not-available></kion-cms-not-available>
</ng-template>
